// src/user/ProfilePanel.jsx

import React, { useContext, useState } from 'react';
import { AuthContext }    from './AuthContext';
import { doc, setDoc }    from 'firebase/firestore';
import { db }             from '../firebase';
import {
  FaUserCircle,
  FaSmile,
  FaDragon,
  FaCat,
  FaGhost,
  FaCrow,
  FaFish,
  FaRobot
} from 'react-icons/fa';
import './ProfilePanel.css';

const ICONS = {
  FaUserCircle: FaUserCircle,
  FaSmile:      FaSmile,
  FaDragon:     FaDragon,
  FaCat:        FaCat,
  FaGhost:      FaGhost,
  FaCrow:       FaCrow,
  FaFish:       FaFish,
  FaRobot:      FaRobot,
};

export default function ProfilePanel() {
  const { user, setUser } = useContext(AuthContext);
  const [showPicker, setShowPicker] = useState(false);

  const handleSelect = async iconName => {
    try {
      // Save to Firestore (create if not exists)
      await setDoc(doc(db, 'users', user.uid), { iconName }, { merge: true });

      // Update context
      setUser(prev => ({ ...prev, iconName }));

      // Close picker
      setShowPicker(false);
    } catch (err) {
      console.error('Failed to update avatar:', err);
    }
  };

  const ChosenIcon = ICONS[user.iconName] || FaUserCircle;

  return (
    <div className="profile-panel">
      <h1>My Profile</h1>

      <div className="profile-details">
        <div
          className="avatar-wrapper"
          onClick={() => setShowPicker(true)}
          title="Click to change avatar"
        >
          <ChosenIcon size={96} />
        </div>
        <div className="info">
          <p><strong>Email:</strong> {user.email}</p>
        </div>
      </div>

      {showPicker && (
        <div className="icon-picker-overlay" onClick={() => setShowPicker(false)}>
          <div className="icon-picker" onClick={e => e.stopPropagation()}>
            {Object.entries(ICONS).map(([name, IconComp]) => (
              <button
                key={name}
                className={`icon-btn${user.iconName === name ? ' selected' : ''}`}
                onClick={() => handleSelect(name)}
              >
                <IconComp size={32} />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
